export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type GQLArticle = {
  __typename?: 'Article';
  articleNumber: Scalars['String']['output'];
  /** The path of an uri pointing to an image of the article */
  assetPath: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the article */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  measureUnit: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};


export type GQLArticlenameArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLBooleanFilter = {
  equal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLBrand = {
  __typename?: 'Brand';
  color: Scalars['String']['output'];
  /** The unique identifier of the brand */
  id: Scalars['ID']['output'];
  logoGrayscalePath: Scalars['String']['output'];
  logoPath: Scalars['String']['output'];
  logoTransparentBackgroundColor: Scalars['String']['output'];
  logoTransparentPath: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type GQLBrandFilter = {
  and?: InputMaybe<Array<GQLBrandFilter>>;
  id?: InputMaybe<GQLStringFilter>;
  name?: InputMaybe<GQLStringFilter>;
  or?: InputMaybe<Array<GQLBrandFilter>>;
  shortName?: InputMaybe<GQLStringFilter>;
};

export type GQLBrandSort = {
  direction?: GQLSortDirection;
  field: GQLBrandSortField;
};

export enum GQLBrandSortField {
  name = 'name',
  shortName = 'shortName'
}

export type GQLCompatibleArticle = {
  __typename?: 'CompatibleArticle';
  articleName: Maybe<Scalars['String']['output']>;
  articleNumber: Scalars['String']['output'];
  brandId: Maybe<Scalars['String']['output']>;
  componentGroupDescription: Scalars['String']['output'];
  componentGroupId: Scalars['String']['output'];
  componentGroupType: GQLComponentType;
  languageCode: Maybe<Scalars['String']['output']>;
  modelArticleNumber: Maybe<Scalars['String']['output']>;
  modelDescription: Maybe<Scalars['String']['output']>;
  modelId: Scalars['ID']['output'];
  modelSpecification: Maybe<Scalars['String']['output']>;
  modelYear: Maybe<Scalars['Int']['output']>;
};

export type GQLCompatibleArticleSort = {
  direction?: GQLSortDirection;
  field: GQLCompatibleArticleSortField;
};

export enum GQLCompatibleArticleSortField {
  articleName = 'articleName',
  articleNumber = 'articleNumber',
  componentGroupDescription = 'componentGroupDescription',
  componentGroupId = 'componentGroupId',
  modelArticleNumber = 'modelArticleNumber',
  modelDescription = 'modelDescription',
  modelSpecification = 'modelSpecification',
  modelYear = 'modelYear'
}

export type GQLCompatibleArticlesFilter = {
  and?: InputMaybe<Array<GQLCompatibleArticlesFilter>>;
  brandId?: InputMaybe<GQLManyToOneFilter>;
  componentGroupId?: InputMaybe<GQLStringFilter>;
  modelSpecification?: InputMaybe<GQLStringFilter>;
  modelYear?: InputMaybe<GQLNumberFilter>;
  or?: InputMaybe<Array<GQLCompatibleArticlesFilter>>;
};

export type GQLComponentGroup = {
  __typename?: 'ComponentGroup';
  children: Array<GQLComponentGroup>;
  /** The code of the component group */
  code: Scalars['String']['output'];
  componentGroupParents: Array<GQLComponentGroupParent>;
  componentSubGroups: Array<GQLComponentSubGroup>;
  componentType: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** The unique identifier of the component group */
  id: Scalars['ID']['output'];
  parent: Maybe<GQLComponentGroup>;
};


export type GQLComponentGroupdescriptionArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLComponentGroupFilter = {
  and?: InputMaybe<Array<GQLComponentGroupFilter>>;
  code?: InputMaybe<GQLStringFilter>;
  componentType?: InputMaybe<GQLComponentTypeEnumFilter>;
  or?: InputMaybe<Array<GQLComponentGroupFilter>>;
  parent?: InputMaybe<GQLManyToOneFilter>;
};

export type GQLComponentGroupParent = {
  __typename?: 'ComponentGroupParent';
  componentAsset: Maybe<Scalars['String']['output']>;
  componentAssetFallback: Maybe<Scalars['String']['output']>;
  componentGroup: GQLComponentGroup;
  componentSubGroups: Array<GQLComponentSubGroup>;
  id: Scalars['ID']['output'];
};

export type GQLComponentGroupSort = {
  direction?: GQLSortDirection;
  field: GQLComponentGroupSortField;
};

export enum GQLComponentGroupSortField {
  code = 'code',
  componentType = 'componentType'
}

export type GQLComponentSubGroup = {
  __typename?: 'ComponentSubGroup';
  componentGroup: GQLComponentGroup;
  componentGroupParent: GQLComponentGroupParent;
  explosionAssetHighResolution: Maybe<Scalars['String']['output']>;
  explosionAssetMediumResolution: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export enum GQLComponentType {
  BicycleAccessories = 'BicycleAccessories',
  BicycleGeneral = 'BicycleGeneral',
  BicycleParts = 'BicycleParts',
  Chassis = 'Chassis',
  Engine = 'Engine',
  Fork = 'Fork',
  Shock = 'Shock',
  SteeringDamper = 'SteeringDamper'
}

export type GQLComponentTypeEnumFilter = {
  equal?: InputMaybe<GQLComponentType>;
  isAnyOf?: InputMaybe<Array<GQLComponentType>>;
  notEqual?: InputMaybe<GQLComponentType>;
};

export type GQLCurrentUserPermission = {
  __typename?: 'CurrentUserPermission';
  contentScopes: Array<Scalars['JSONObject']['output']>;
  permission: GQLPermission;
};

export type GQLDamMediaAlternative = {
  __typename?: 'DamMediaAlternative';
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  type: GQLDamMediaAlternativeType;
};

export enum GQLDamMediaAlternativeType {
  captions = 'captions'
}

export type GQLDependency = {
  __typename?: 'Dependency';
  jsonPath: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  rootColumnName: Scalars['String']['output'];
  rootGraphqlObjectType: Scalars['String']['output'];
  rootId: Scalars['String']['output'];
  secondaryInformation: Maybe<Scalars['String']['output']>;
  targetGraphqlObjectType: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type GQLEntityInfo = {
  __typename?: 'EntityInfo';
  entityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secondaryInformation: Maybe<Scalars['String']['output']>;
};

export enum GQLFocalPoint {
  CENTER = 'CENTER',
  NORTHEAST = 'NORTHEAST',
  NORTHWEST = 'NORTHWEST',
  SMART = 'SMART',
  SOUTHEAST = 'SOUTHEAST',
  SOUTHWEST = 'SOUTHWEST'
}

export type GQLImageCropArea = {
  __typename?: 'ImageCropArea';
  focalPoint: GQLFocalPoint;
  height: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type GQLManyToOneFilter = {
  equal?: InputMaybe<Scalars['ID']['input']>;
  isAnyOf?: InputMaybe<Array<Scalars['ID']['input']>>;
  notEqual?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLModel = {
  __typename?: 'Model';
  articleNumber: Maybe<Scalars['String']['output']>;
  /** The path to the model picture */
  assetPath: Scalars['String']['output'];
  brand: Maybe<GQLBrand>;
  /** The child models of the model */
  children: Array<GQLModel>;
  /** The color of the model */
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** The article number of the engine of the model */
  engineArticleNumber: Maybe<Scalars['String']['output']>;
  engineComponentGroupParents: Array<GQLComponentGroupParent>;
  frameComponentGroupParents: Array<GQLComponentGroupParent>;
  /** The unique identifier of the model */
  id: Scalars['ID']['output'];
  isOem: Scalars['Boolean']['output'];
  isWpArticle: Scalars['Boolean']['output'];
  modelSpecifications: Array<GQLModelSpecification>;
  modelTypes: Array<GQLModelType>;
  /** The parent model of the model */
  parent: Maybe<GQLModel>;
  wpArticles: Array<GQLModel>;
  /** The year of the model */
  year: Maybe<Scalars['Int']['output']>;
};

export type GQLModelFilter = {
  articleNumber?: InputMaybe<GQLStringFilter>;
  brand?: InputMaybe<GQLManyToOneFilter>;
  description?: InputMaybe<GQLStringFilter>;
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasVisibleDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isWpArticle?: InputMaybe<GQLBooleanFilter>;
  parent?: InputMaybe<GQLManyToOneFilter>;
  specification?: InputMaybe<Scalars['String']['input']>;
};

export type GQLModelSort = {
  direction?: GQLSortDirection;
  field: GQLModelSortField;
};

export enum GQLModelSortField {
  articleNumber = 'articleNumber',
  description = 'description'
}

export type GQLModelSpecification = {
  __typename?: 'ModelSpecification';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLModelSpecificationFilter = {
  and?: InputMaybe<Array<GQLModelSpecificationFilter>>;
  name?: InputMaybe<GQLStringFilter>;
  or?: InputMaybe<Array<GQLModelSpecificationFilter>>;
};

export type GQLModelSpecificationSort = {
  direction?: GQLSortDirection;
  field: GQLModelSpecificationSortField;
};

export enum GQLModelSpecificationSortField {
  name = 'name'
}

export type GQLModelType = {
  __typename?: 'ModelType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLNumberFilter = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanEqual?: InputMaybe<Scalars['Float']['input']>;
  isAnyOf?: InputMaybe<Array<Scalars['Float']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  lowerThan?: InputMaybe<Scalars['Float']['input']>;
  lowerThanEqual?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLPaginateCompatibleArticles = {
  __typename?: 'PaginateCompatibleArticles';
  nodes: Array<GQLCompatibleArticle>;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedBrands = {
  __typename?: 'PaginatedBrands';
  nodes: Array<GQLBrand>;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedComponentGroups = {
  __typename?: 'PaginatedComponentGroups';
  nodes: Array<GQLComponentGroup>;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedModelSpecifications = {
  __typename?: 'PaginatedModelSpecifications';
  nodes: Array<GQLModelSpecification>;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedModels = {
  __typename?: 'PaginatedModels';
  nodes: Array<GQLModel>;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedSpareParts = {
  __typename?: 'PaginatedSpareParts';
  nodes: Array<GQLSparePart>;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedWishlistSpareParts = {
  __typename?: 'PaginatedWishlistSpareParts';
  nodes: Array<GQLWishlistSparePart>;
  totalCount: Scalars['Int']['output'];
};

export enum GQLPermission {
  blockPreview = 'blockPreview',
  builds = 'builds',
  cronJobs = 'cronJobs',
  dam = 'dam',
  dependencies = 'dependencies',
  fileUploads = 'fileUploads',
  fullTextSearch = 'fullTextSearch',
  impersonation = 'impersonation',
  pageTree = 'pageTree',
  prelogin = 'prelogin',
  sitePreview = 'sitePreview',
  translation = 'translation',
  userPermissions = 'userPermissions',
  warnings = 'warnings'
}

export type GQLQuery = {
  __typename?: 'Query';
  brand: GQLBrand;
  brands: GQLPaginatedBrands;
  compatibleArticles: GQLPaginateCompatibleArticles;
  componentGroup: GQLComponentGroup;
  componentGroups: GQLPaginatedComponentGroups;
  docVersions: Array<Scalars['String']['output']>;
  model: GQLModel;
  modelByArticleNumber: Maybe<GQLModel>;
  modelSpecification: GQLModelSpecification;
  modelSpecifications: GQLPaginatedModelSpecifications;
  models: GQLPaginatedModels;
  modelsByArticleNumbers: GQLPaginatedModels;
  sparePart: GQLSparePart;
  spareParts: GQLPaginatedSpareParts;
  wishlist: GQLPaginatedWishlistSpareParts;
};


export type GQLQuerybrandArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerybrandsArgs = {
  filter?: InputMaybe<GQLBrandFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<GQLBrandSort>>;
};


export type GQLQuerycompatibleArticlesArgs = {
  articleNameSearch?: InputMaybe<Scalars['String']['input']>;
  articleNumberSearch?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GQLCompatibleArticlesFilter>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  modelSearch?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<GQLCompatibleArticleSort>>;
};


export type GQLQuerycomponentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerycomponentGroupsArgs = {
  filter?: InputMaybe<GQLComponentGroupFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<GQLComponentGroupSort>>;
};


export type GQLQuerymodelArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerymodelByArticleNumberArgs = {
  articleNumber: Scalars['String']['input'];
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GQLQuerymodelSpecificationArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerymodelSpecificationsArgs = {
  filter?: InputMaybe<GQLModelSpecificationFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<GQLModelSpecificationSort>>;
};


export type GQLQuerymodelsArgs = {
  filter?: InputMaybe<GQLModelFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<GQLModelSort>>;
};


export type GQLQuerymodelsByArticleNumbersArgs = {
  articleNumbers: Array<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type GQLQuerysparePartArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerysparePartsArgs = {
  filter?: InputMaybe<GQLSparePartFilter>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<Array<GQLSparePartSort>>;
};


export type GQLQuerywishlistArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  spareParts: Array<GQLSparePartModel>;
};

export enum GQLSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type GQLSparePart = {
  __typename?: 'SparePart';
  article: Maybe<GQLArticle>;
  componentGroup: GQLComponentGroup;
  hotspots: Array<GQLSparePartHotspot>;
  /** The unique identifier of the spare part */
  id: Scalars['ID']['output'];
  isNew: Scalars['Boolean']['output'];
  lineNumber: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type GQLSparePartFilter = {
  componentGroupId: Scalars['ID']['input'];
  modelId: Scalars['ID']['input'];
};

export type GQLSparePartHotspot = {
  __typename?: 'SparePartHotspot';
  endX: Scalars['Float']['output'];
  endY: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  startX: Scalars['Float']['output'];
  startY: Scalars['Float']['output'];
};

export type GQLSparePartModel = {
  modelId: Scalars['String']['input'];
  sparePartId: Scalars['String']['input'];
};

export type GQLSparePartSort = {
  direction?: GQLSortDirection;
  field: GQLSparePartSortField;
};

export enum GQLSparePartSortField {
  sortOrder = 'sortOrder'
}

export type GQLStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  isAnyOf?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUserPermissionsUser = {
  __typename?: 'UserPermissionsUser';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GQLWarning = {
  __typename?: 'Warning';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  scope: Maybe<Scalars['JSONObject']['output']>;
  severity: GQLWarningSeverity;
  sourceInfo: GQLWarningSourceInfo;
  status: GQLWarningStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum GQLWarningSeverity {
  high = 'high',
  low = 'low',
  medium = 'medium'
}

export type GQLWarningSourceInfo = {
  __typename?: 'WarningSourceInfo';
  jsonPath: Maybe<Scalars['String']['output']>;
  rootColumnName: Maybe<Scalars['String']['output']>;
  rootEntityName: Scalars['String']['output'];
  rootPrimaryKey: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
};

export type GQLWarningSourceInfoInput = {
  jsonPath?: InputMaybe<Scalars['String']['input']>;
  rootColumnName?: InputMaybe<Scalars['String']['input']>;
  rootEntityName: Scalars['String']['input'];
  rootPrimaryKey: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
};

export enum GQLWarningStatus {
  ignored = 'ignored',
  open = 'open',
  resolved = 'resolved'
}

export type GQLWishlistSparePart = {
  __typename?: 'WishlistSparePart';
  article: Maybe<GQLArticle>;
  id: Scalars['String']['output'];
  model: GQLModel;
  quantity: Scalars['Int']['output'];
};
